// src/utils/invoiceOwing.js
//
// x2owing-6c1e9b37 — X2 (security audit 2026-10-15 #2). The web copy of the server's "is owing"
// rule (functions/utils/invoiceChargeable.js isInvoiceOwing). The React bundle cannot import
// from functions/, so it is copied; src/utils/invoiceOwing.test.js runs both copies on the same
// cases, so a drift fails a test.
//
// An invoice is OWING unless it is Paid, Written Off (status or writtenOff: true), Void /
// Voided, Cancelled / Canceled, or a Draft. Compared trimmed and lower-cased. The spread preview
// uses it so it shows exactly what the server's spread will do.

const NOT_OWING = ['paid', 'written off', 'void', 'voided', 'cancelled', 'canceled', 'draft'];

export function isInvoiceOwing(inv) {
    if (!inv) return false;
    if (inv.writtenOff === true) return false;
    return !NOT_OWING.includes(String(inv.status || '').trim().toLowerCase());
}

// x2bweb-99626d17 — X2b: the web copy of the server's invoiceChargeable.isInvoiceClosed — the
// rule applyCreditToInvoiceCore refuses a credit on. Paid, Written Off (status or writtenOff:
// true), Void / Voided, Cancelled / Canceled. A Draft is NOT closed (a credit on a Draft stays
// allowed). The Apply Credit button hides on exactly these. Pinned by invoiceOwing.test.js.
const CLOSED = ['paid', 'written off', 'void', 'voided', 'cancelled', 'canceled'];

export function isInvoiceClosed(inv) {
    if (!inv) return false;
    if (inv.writtenOff === true) return true;
    return CLOSED.includes(String(inv.status || '').trim().toLowerCase());
}
